import { render, staticRenderFns } from "./RIRefHelplist.vue?vue&type=template&id=324188bf&"
import script from "./RIRefHelplist.vue?vue&type=script&lang=js&"
export * from "./RIRefHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports